module.exports = __webpack_public_path__ + "93f7c2590937d12e4681296ba12b06e3.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/ikons/ikons.woff
 ** module id = ./src/styles/fonts/ikons/ikons.woff
 ** module chunks = 0
 **/